<template>
  <w-tool-tabs class="tab-button" size="mini" v-model="activeTab">
    <el-tab-pane label="컨트롤러" name="WControllerPerfTable">
      <w-controller-perf-table :active="active && activeTab === 'WControllerPerfTable'" />
    </el-tab-pane>
    <el-tab-pane label="무선 AP" name="WAccessPointPerfTable">
      <w-access-point-perf-table :active="active && activeTab === 'WAccessPointPerfTable'" />
    </el-tab-pane>
  </w-tool-tabs>
</template>

<script>
import WControllerPerfTable from '@/views/performance/components/wireless/ControllerPerfTable';
import WAccessPointPerfTable from '@/views/performance/components/wireless/AccessPointPerfTable';

export default {
  name: 'WWirelessPerfView',
  components: {
    WControllerPerfTable,
    WAccessPointPerfTable,
  },
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      activeTab: 'WControllerPerfTable',
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/group/perfinfo/components/WirelessPerfView.vue